import Vue from "vue";
import Vuex from "vuex";
import userStore from "./modules/user.store";
import affiliateStore from "./modules/affiliate.store";
import clientStore from "./modules/client.store";
import clientFilter from "./modules/client.filter.store";
import referralStore from "./modules/referral.store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user: userStore,
    affiliateStore,
    clientStore,
    clientFilter,
    referralStore,
  },
});
